<template>
  <div class="main">
    <van-pull-refresh v-model="loading" @refresh="onRefresh">
      <van-skeleton :row="30" :loading="vLoading">
        <div class="topBanner">
          <div class="bgc"></div>

          <div class="tab-change">
            <p class="wyqymc" @click="openArea">
              {{ currentWyqy }}

              <!-- <van-icon class="arrow" name="arrow-down" /> -->
            </p>
            <van-button
              @click="openArea"
              class="arrow"
              :icon="arrow"
              type="primary"
              >切换房屋</van-button
            >
          </div>
          <span>切换房屋，查看对应投票与公示信息</span>
          <van-popup v-model="showArea" position="bottom">
            <van-cascader
              active-color="#ff6c1a"
              v-model="cascaderValue"
              title="请选择物业区域"
              :options="columns"
              @close="showArea = false"
              @finish="onFinish"
            />
          </van-popup>
          <div class="wxzjContral">
            <div class="wxzjbox">
              <div class="item1" @click="handlerSelect('search')">
                <div class="title-text">资金查询</div>
                <div class="beizhu">快速查找资金</div>
              </div>
              <div class="item2" @click="handlerSelect('save')">
                <div class="title-text">资金交存</div>
                <div class="beizhu">线上完成交存</div>

                <!-- <img src="../assets/img/btn_img_zjjc.png" alt="" /> -->
                <!-- <span>资金交存</span> -->
              </div>
              <!-- <div class="item" @click="handlerSelect('checkout')">
            <img src="../assets/img/index_main_icon_kaipiao.png" alt="" />
            <span>敬请期待</span>
          </div> -->
            </div>
          </div>
        </div>
        <!-- 近期投票 -->
        <div class="nearVote">
          <div class="title">
            <span>
              <img src="../assets/img/img_title.png" alt="" />
              近期投票</span
            >
            <span class="more" @click="gotoVote">查看更多 >></span>
            <div class="VoteMain">
              <!-- <voteItem ref="vote" :wyqyId="wyqyId"></voteItem> -->
              <div v-if="listLength">
                <div
                  class="voteBox"
                  v-for="(item, index) in currentData"
                  :key="index"
                  @click="getVoteInfo(item)"
                >
                  <div class="time">
                    距离投票结束还剩:
                    <span>
                      <van-count-down
                        :time="item.time"
                        format="DD 天 HH 时 mm 分 "
                      />
                    </span>
                  </div>
                  <div class="voteName">
                    <img src="../assets/img/ico_toupiao.png" alt="" />
                    <div class="name">{{ item.tpmc }}</div>
                  </div>

                  <div class="voteBottom">
                    <div class="voteIn">
                      <img src="../assets/img/ico_renshu.png" alt="" />
                      <span style="font-size: 13px"
                        >参与:{{ item.tprs }}人</span
                      >
                    </div>

                    <div class="VoteType">{{ item.tplx | title }}</div>

                    <van-button
                      style="font-size: 13px; color: #fff"
                      v-if="item.grtpzt == 1 || item.grtpzt == 2"
                      :disabled="item.grtpzt == 2"
                      color="#ff6c19"
                    >
                      <span style="font-size: 13px; color: #fff">
                        {{ item.grtpzt | btn }}</span
                      >
                    </van-button>

                    <van-button v-else disabled color="#BABABA">
                      <span style="font-size: 13px; color: #fff">
                        {{ item.grtpzt | btn }}</span
                      >
                    </van-button>
                  </div>
                </div>
              </div>
              <div
                v-if="vLoading"
                style="width: 100% height: 100px; text-align: center; margin-top: 40px"
              >
                <van-loading size="30px">加载中...</van-loading>
              </div>
              <div class="content" v-if="!vLoading && !currentData.length">
                <div class="top">
                  <div class="image"></div>
                </div>
                <div class="footer">
                  <p class="nodata">暂无数据</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 近期公示 -->
        <div class="nearPublic">
          <div class="title">
            <span>
              <img src="../assets/img/img_title.png" alt="" />
              近期公示</span
            >
            <span class="more" @click="gotoPublic">查看更多 >></span>
            <div class="publicMain">
              <!-- <publicItemIndex ref="public" :wyqyId="wyqyId" class="public-box"></publicItemIndex> -->
              <div
                v-if="dataList.length"
                class="scorllBox"
                :style="{
                  width: dataList.length * 240 - 20 + 'px',
                }"
              >
                <div
                  class="item"
                  v-for="(item, index) in dataList"
                  :key="'data_' + index"
                  @click="getInfo(item)"
                >
                  <img
                    v-if="item.gszt == 2"
                    class="icon"
                    src="../assets/img/img_ing.png"
                    alt=""
                  />
                  <img
                    v-else-if="item.gszt == 3"
                    class="icon"
                    src="../assets/img/img_finish.png"
                    alt=""
                  />
                  <div class="name">{{ item.gsmc }}</div>
                  <div class="time">发布时间：{{ item.gsfqsj }}</div>
                </div>
              </div>

              <div
                v-if="vLoading"
                style="
                  width: 100%;
                  height: 100px;
                  text-align: center;
                  margin-top: 40px;
                "
              >
                <van-loading size="30px">加载中...</van-loading>
              </div>
              <div class="content" v-if="!vLoading && !dataList.length">
                <div class="top">
                  <div class="image"></div>
                </div>
                <div class="footer">
                  <p class="nodata">暂无数据</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-skeleton>
    </van-pull-refresh>
  </div>
</template>

<script>
import voteItem from "./components/voteItem.vue";
import publicItemIndex from "./components/publicItemIndex.vue";
import api from "@/api/query.js";
import login from "@/api/login.js";
import pub from "@/api/home.js";
import vote from "@/api/vote.js";
import { ref } from "vue";
export default {
  components: { voteItem, publicItemIndex },
  data() {
    return {
      time: "",
      dataList: [], // 公示列表
      currentData: [], // 投票列表
      vLoading: true,
      showArea: false,
      columns: [], // 物业区域下拉数据
      wyqyId: null,
      currentWyqy: "", //物业区域房屋名称
      wyqydm: "", // 物业区域代码
      openId: "",
      userinfo: {},
      currentwyqyId: null, //当前物业区域ID
      currentwyqydm: null, // 当前物业区域代码
      loading: false,
      currentFwid: null, // 当前选中房屋Id
      cascaderValue: null, // 级联选择器回显值
      flag: false,
      arrow: "arrow-down",
    };
  },
  created() {
    this.wyqyId = Number(sessionStorage.getItem("wyqy"));
    this.currentwyqyId = sessionStorage.getItem("wyqy");
    this.currentwyqydm = sessionStorage.getItem("wyqydm");
    // this.getToken()
  },
  mounted() {
    // //本地测试
    // this.loginFnc();

    // 线上测试
    // let openId = sessionStorage.getItem("openId");
    // this.openId = openId;
    // if (openId) {
    //   this.loginFnc();
    // } else {
    //   this.getUserCode();
    // }

    // 新环境配置
    // this.openId = "o71E55oKKccRcsgcBxSDhZe6-zEA";
    this.openId = sessionStorage.getItem("openId");
    this.flag = sessionStorage.getItem("flag");

    if (!this.openId) {
      //初次进入页面 获取openId
      this.getQueryString();
    } else if (!this.flag) {
      this.loginFnc();
    } else if (this.openId && this.flag) {
      this.getWyquList();
      this.getUserinfo();
    }
  },

  methods: {
    //解析url获取指定参数的值
    getQueryString() {
      // const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
      // const search = window.location.search.split('?')[1] || '';
      // const r = search.match(reg) || [];
      // return r[2];
      var url = window.location.search.split("=");
      let code = url[1];
      this.getOpenId(code);
    },

    //获取token
    getToken() {
      login.getToken().then((res) => {
        if (res.data.code == 200) {
          sessionStorage.setItem("token", res.data);
        }
      });
    },

    //登录
    loginFnc() {
      sessionStorage.setItem("openId", this.openId);
      login
        .Login({ openId: this.openId })
        .then((res) => {
          if (res.data.msg == "NoRegister") {
            this.$toast.success({
              message: "当前账号未注册信息，即将前往注册! ",
            });
            location.href = "/register";
          } else {
            if (res.data.code == 200) {
              sessionStorage.setItem("token", res.data.data.accessToken);
              this.getWyquList();
              this.getUserinfo();
              this.flag = true;
              sessionStorage.setItem("flag", this.flag);
            } else {
              this.$toast.fail({
                message: res.data.msg,
              });
              // location.href = '/register'
            }
          }
        })
        .catch((err) => {});
    },
    // 获取code
    getUserCode() {
      var url = location.href;
      let start = location.href.indexOf("=");
      let end = location.href.indexOf("&");
      let code = url.substring(start + 1, end);
      this.getOpenId(code);
    },
    getOpenId(code) {
      login
        .openid(code)
        .then((res) => {
          if (res.data.code == 200) {
            this.openId = res.data.data.openId;
            sessionStorage.setItem("openId", res.data.data.openId);
            this.loginFnc();
          } else {
            this.$toast.fail({
              message: res.data.msg,
            });
          }
        })
        .catch((err) => {
          this.$toast.fail({
            message: "获取用户id失败",
          });
        });
    },
    //刷新
    onRefresh() {
      this.loading = true;
      let openId = sessionStorage.getItem("openId");
      this.openId = openId;
      this.getWyquList();
      this.getUserinfo();
    },

    handlerSelect(type) {
      if (type == "search") {
        location.href = "/search" + "?wyqydm=" + this.currentWyqy;
        // this.$router.push({ path: '/search', query: { wyqydm: this.currentWyqy } })
      } else if (type == "save") {
        location.href = "/fundSave" + "?wyqydm=" + this.currentWyqy;

        // this.$router.push({ path: '/fundSave', query: { wyqydm: this.currentWyqy } })
      } else {
        this.$toast.fail({
          message: "暂未开发",
        });
        // this.$router.push({ path: '/checkout', query: { wyqydm: this.currentWyqy } })
      }
    },

    //物业区域
    getWyquList() {
      let open = sessionStorage.getItem("openId");
      api
        .listWyqy({ openId: open })
        .then((res) => {
          if (res.data.code == 200) {
            // 物业区域数据
            this.columns = res.data.data;
            for (let index = 0; index < this.columns.length; index++) {
              this.columns[index].value = this.columns[index].id;
              this.columns[index].index = index;
              for (let q = 0; q < this.columns[index].children.length; q++) {
                this.columns[index].children[q].value =
                  this.columns[index].children[q].id;
              }
            }
          } else {
            this.$toast.fail({
              message: res.data.msg,
            });
          }
        })
        .catch((err) => {});
    },
    // 获取公示列表
    getList() {
      let params = {
        // gslx: 0,
        openId: sessionStorage.getItem("openId"),
        wyqyId: Number(this.wyqyId),
        fwId: sessionStorage.getItem("fwId"),
      };
      this.vLoading = true;
      pub
        .homeGsList(params)
        .then((res) => {
          if (res.data.code == 200 && res.data.data) {
            this.dataList = res.data.data.splice(0, 3);
            this.dataList.forEach((item) => {
              item.gsfqsj = item.gsfqsj.slice(0, 10);
            });
            this.loading = false;
            this.vLoading = false;
          } else {
            this.vLoading = false;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.vLoading = false;
          this.loading = false;
        });
    },
    // 获取投票
    getVoteList() {
      let params = {
        openId: sessionStorage.getItem("openId"),
        tplx: this.active,
        wyqyId: Number(this.wyqyId),
        fwId: sessionStorage.getItem("fwId"),
      };
      this.vLoading = true;
      vote
        .voteList(params)
        .then((res) => {
          if (res.data.code == 200 && res.data.data) {
            this.currentData = res.data.data.splice(0, 2);
            this.currentData.forEach((item) => {
              let toDay = new Date().getTime();
              let end = new Date(item.tpjssj).getTime();
              item.time = end - toDay;
            });
            this.vLoading = false;
          } else {
            this.vLoading = false;
          }
        })
        .catch((err) => {
          this.$toast.fail({
            message: err,
          });
          this.vLoading = false;
        });
    },

    // 级联选择器结束事件
    onFinish({ selectedOptions }) {
      this.arrow = "arrow-down";
      this.showArea = false;
      this.currentWyqy = selectedOptions.map((option) => option.text).join("");
      this.currentFwid = selectedOptions[1].id;
      // 缓存房屋相关数据
      sessionStorage.setItem("currentWyqy", this.currentWyqy);
      sessionStorage.setItem("wyqy", selectedOptions[0].id);
      sessionStorage.setItem("wyqydm", selectedOptions[0].wyqydm);
      sessionStorage.setItem("fwId", this.currentFwid);
      this.currentwyqydm = selectedOptions[0].wyqydm;
      this.currentwyqyId = selectedOptions[0].id;
      this.getUserinfo();
    },

    onCancel() {
      this.showArea = false;
    },
    openArea() {
      this.showArea = true;
    },
    gotoVote() {
      location.href = "/vote";
    },
    gotoPublic() {
      location.href = "/publicity";
    },
    getUserinfo() {
      login
        .info({ openId: this.openId })
        .then((res) => {
          if (res.data.code == 200) {
            let obj = JSON.stringify(res.data.data);
            sessionStorage.setItem("userinfo", obj);
            if (!this.currentwyqydm || !this.currentwyqyId) {
              // 页面初始化加载用户默认房屋的物业区域
              if (res.data.data.yzfwVo.length) {
                this.currentWyqy = res.data.data.yzfwVo[0].fwmc;
                sessionStorage.setItem("currentWyqy", this.currentWyqy);

                this.currentFwid = res.data.data.yzfwVo[0].fwId;
                this.wyqyId = res.data.data.yzfwVo[0].wyqyId;
                sessionStorage.setItem("wyqy", this.wyqyId);
                sessionStorage.setItem("fwId", res.data.data.yzfwVo[0].fwId);
                sessionStorage.setItem("wyqydm", res.data.data.mrfwwyqydm);
                sessionStorage.setItem("wyqy", res.data.data.mrfwwyqyId);
                this.cascaderValue = res.data.data.yzfwVo[0].fwId;
                this.currentWyqy = res.data.data.yzfwVo[0].fwmc;
              }
            } else {
              this.currentWyqy = sessionStorage.getItem("currentWyqy");
              this.cascaderValue = Number(sessionStorage.getItem("fwId"));
            }
            this.getList();
            this.getVoteList();
          } else if (res.data.msg == "NoRegister") {
            this.$toast.fail({
              message: "当前账号未注册信息，即将前往注册!",
            });
            location.href = "/register";
          }
        })
        .catch((err) => {
          console.log("===", err);
          this.$toast.fail({
            message: err,
          });
        });
    },
    getVoteInfo(item) {
      location.href =
        "/detail" +
        "?id=" +
        item.id +
        "&tplx=" +
        item.tplx +
        "&fwId=" +
        item.fwId;
      // this.$router.push({ path: '/detail', query: { id: item.id, tplx: item.tplx, fwId: item.fwId } })
    },
    getInfo(item) {
      if (item.gslx == 0) {
        // this.$router.push({
        //   path: "/useDetail",
        //   query: { id: item.id },
        // });
        location.href = "/useDetail" + "?id=" + item.id;
      } else if (item.gslx == 1) {
        // this.$router.push({
        //   path: "/votepublic",
        //   query: { id: item.id },
        // });
        location.href = "/publicVote" + "?id=" + item.id;
      } else {
        location.href = "/publicDetail" + "?id=" + item.id;
        // this.$router.push({
        //   path: "/publicDetail",
        //   query: { id: item.id },
        // });
      }
    },
  },
  computed: {
    listLength() {
      return this.currentData.length;
    },
  },
  filters: {
    title(val) {
      if (val == 0 || val == 1) {
        return "使用投票";
      } else {
        return "验收投票";
      }
    },
    btn(val) {
      let msg = "";
      switch (val) {
        case 0:
          msg = "未开始";
          break;
        case 1:
          msg = "我要投票";
          break;
        case 2:
          msg = "已投票";
          break;
        case 3:
          msg = "已结束";
          break;
        default:
          msg = "未开始";
          break;
      }
      return msg;
    },
    adress(val) {
      if (val.length > 13) {
        val = val.substring(0, 13) + "....";
      }
      return val;
    },
  },
  watch: {
    showArea(nval) {
      if (nval) {
        this.arrow = "arrow-up";
      } else {
        this.arrow = "arrow-down";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  background-color: #f4f7f9;
  min-height: 100vh;
}

.topBanner {
  width: 100%;
  height: 140px;
  background: url("../assets/img/index_img_topbg.png");
  background-size: 100% 100%;
  position: relative;

  .tab-change {
    position: relative;

    .van-button--primary {
      position: absolute;
      top: 30px;
      left: 215px;
      background-color: #ff7425;
      border: none;
      border-radius: 30px;
      width: 110px;
      font-size: 14px;
      height: 30px;
    }

    .van-button__text {
      margin: 0;
    }
  }

  .wyqymc {
    position: absolute;
    width: 200px;
    left: 20px;
    top: 33px;
    font-size: 18px;
    color: #222120;
    margin: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .adress {
    position: relative;
    width: 60%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  & > span {
    position: absolute;
    left: 20px;
    top: 64px;
    font-size: 13px;
    color: #6b6a6a;
  }

  .wxzjContral {
    width: 100%;
    padding: 0 20px;
    position: absolute;
    left: 0;
    top: 101px;

    .wxzjbox {
      width: 100%;
      border-radius: 3px;
      display: flex;
      text-align: center;
      justify-content: space-between;

      .item1 {
        width: 48%;
        height: 100px;
        position: relative;
        background: url(../assets/img/index_img_zjcx.png) no-repeat;
        background-size: 100% 100%;
        // img {
        //   display: block;
        //   margin: 0 auto;
        //   margin-bottom: 4px;
        //   width: 60px;
        //   height: 60px;
        // }

        // span {
        //   font-size: 13px;
        //   text-align: center;
        //   color: #4e4d4d;
        // }
      }

      .beizhu {
        line-height: 14px;
        text-align: left;
        padding: 8px 16px;
        font-size: 12px;
        color: #ffffff;
        height: 17px;
      }

      .title-text {
        // margin: 20px 0 20px 0;
        font-family: PingFang SC-Semibold, PingFang SC;
        color: #ffffff;
        height: 21px;
        line-height: 18px;
        text-align: left;
        font-weight: 500;
        font-size: 15px;
        padding: 16px;
      }

      .item2 {
        position: relative;
        width: 48%;
        height: 100px;
        background: url(../assets/img/index_img_zjjc.png) no-repeat;
        background-size: 100% 100%;
      }
    }
  }
}

.nearVote,
.nearPublic {
  margin-top: 90px;
  padding: 0 20px;

  .title {
    img {
      width: 16px;
    }

    span {
      color: #222120;
      font-size: 18px;

      &.more {
        color: #999998;
        font-size: 14px;
        float: right;
      }
    }
  }
}

.publicMain {
  width: 100%;
  overflow-x: auto;
  margin-top: 20px;

  &::-webkit-scrollbar {
    width: 1px;
    height: 1px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: transparent;
  }

  &::after {
    content: "";
    display: block;
    width: 0;
    height: 0;
    clear: both;
  }

  .scorllBox {
    height: 100%;
    width: 200%;
  }

  .item {
    padding: 16px;
    width: 220px;
    background-color: #fff;
    height: 126px;
    border-radius: 3px;
    float: left;
    position: relative;

    .icon {
      position: absolute;
      top: 15px;
      right: -2px;
      width: 56px;
      height: 26px;
    }

    & + .item {
      margin-left: 20px;
    }

    .name {
      color: #222120;
      font-size: 16px;
      font-weight: bold;
      line-height: 1.5;
      width: 140px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .time {
      display: inline-block;
      font-size: 12px;
      color: #999998;
      background-color: #f7f7f7;
      padding: 3px 10px;
      margin-top: 16px;
      line-height: 24px;
    }
  }
}

.scorllBox {
  height: 100%;
  width: 200%;
}

.nearPublic {
  margin-top: 32px;
  padding-bottom: 70px;
}

.content {
  // height: 100%;

  .top {
    width: 180px;
    height: 200px;
    padding: 15px;
    position: relative;
    top: 10px;
    left: 50%;
    margin-left: -100px;
    text-align: center;
    // border: 1px dashed #4e4d4d;

    .image {
      width: 100%;
      height: 100%;
      background: url("../assets/img/img_toupiao_nodata.png") no-repeat;
      background-size: 100% 100%;
      // border: 1px dashed #4e4d4d;
    }

    .nadata {
      margin-top: 20px;
      font-size: 14px !important;
      font-weight: 400 !important;
      color: #4e4d4d !important;
    }
  }

  .footer {
    width: 100%;
    height: 33px;
    text-align: center;
    font-size: 14px !important;
    font-weight: 400 !important;
    color: #4e4d4d !important;
  }
}

.voteBox {
  width: 100%;
  background: #fff;
  margin-top: 20px;
  border-radius: 3px;
  padding-bottom: 16px;

  &::after {
    content: "";
    display: block;
    height: 0;
    width: 0;
    clear: both;
  }

  .time {
    width: 244px;
    height: 30px;
    background: linear-gradient(96deg, #ffd8c1 0%, #fff6f1 100%);
    border-radius: 8px 0 24px 0px;
    font-size: 12px;
    color: #ff6c1a;
    padding-left: 12px;
    line-height: 30px;

    span {
      color: #ff6c1a;
      font-size: 15px;
      font-weight: bold;
      padding: 0 3px;
    }
  }

  .voteName {
    margin-top: 16px;
    padding: 0 16px;
    display: flex;

    img {
      display: block;
      width: 22px;
      height: 22px;
    }

    .name {
      margin-left: 3px;
      min-height: 21px;
      color: #222120;
      font-weight: bold;
      width: 70%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .voteBottom {
    padding: 0 16px;
    margin-top: 20px;

    button {
      padding: 0 17px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      background-color: #ff6c1a;
      color: #fff;
      border-radius: 30px;
      float: right;
      border: none;
      font-size: 13px;
    }

    .voteIn,
    .VoteType {
      display: inline-block;
      font-size: 13px;
      line-height: 30px;
      padding: 0 5px;
      border-radius: 3px;
    }

    .voteIn {
      background: #f7f7f7;
      color: #6b6a6a;
      border: 1px solid #e9e9e9;
      letter-spacing: 1px;

      img {
        // margin-top: 5px;
        margin-top: 6px;
        margin-right: 5px;
        float: left;
        width: 16px;
        height: 16px;
      }
    }

    .VoteType {
      color: #00c797;
      background: rgba(0, 199, 151, 0.05);
      border: 1px solid #00c797;
      margin-left: 5px;
    }
  }
}

.van-button__text {
  font-size: 13px;
}

.van-count-down {
  display: inline-block;
  color: #ff6c19;
  width: 120px;
}

/deep/.van-cascader__tab {
  font-size: 16px;
}

/deep/.van-cascader__option {
  font-size: 15px;
}
</style>
